import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { siteInfo, categories } from '@/mocks/data';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';
  const navBg = scrolled || !isHome ? 'bg-background-50/95 backdrop-blur-md shadow-sm' : 'bg-transparent';
  const textColor = scrolled || !isHome ? 'text-foreground-950' : 'text-white';
  const btnBg = scrolled || !isHome ? 'bg-foreground-950 text-background-50' : 'bg-white text-foreground-950';

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${navBg}`}>
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Left nav links */}
          <div className="hidden md:flex items-center gap-6 lg:gap-8">
            <Link to="/category/celebrity" className={`text-sm font-medium ${textColor} hover:opacity-80 transition-opacity whitespace-nowrap`}>
              爆料库
            </Link>
            <Link to="/category/influencer" className={`text-sm font-medium ${textColor} hover:opacity-80 transition-opacity whitespace-nowrap`}>
              明星车
            </Link>
            <Link to="/category/social" className={`text-sm font-medium ${textColor} hover:opacity-80 transition-opacity whitespace-nowrap`}>
              全网热搜
            </Link>
          </div>

          {/* Brand */}
          <Link to="/" className="absolute left-1/2 -translate-x-1/2 flex items-center gap-1">
            <span className={`font-heading text-xl md:text-2xl font-bold ${textColor} tracking-tight`}>
              {siteInfo.name}
            </span>
            <span className="w-2 h-2 rounded-full bg-primary-500 inline-block" />
          </Link>

          {/* Right nav links */}
          <div className="hidden md:flex items-center gap-6 lg:gap-8">
            <Link to="/about" className={`text-sm font-medium ${textColor} hover:opacity-80 transition-opacity whitespace-nowrap`}>
              投稿入口
            </Link>
            <Link to="/about" className={`text-sm font-medium ${textColor} hover:opacity-80 transition-opacity whitespace-nowrap`}>
              用户中心
            </Link>
            <button className={`px-5 py-2 rounded-full text-sm font-medium ${btnBg} transition-all hover:opacity-90 whitespace-nowrap`}>
              登录
            </button>
          </div>

          {/* Mobile hamburger */}
          <button
            className={`md:hidden p-2 ${textColor}`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="切换导航"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl w-6 h-6 flex items-center justify-center`} />
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-md border-t border-background-200/70 px-4 py-4 shadow-lg">
          <div className="flex flex-col gap-3">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="text-foreground-950 text-sm font-medium py-2 border-b border-background-200/50"
              >
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="text-foreground-950 text-sm font-medium py-2 border-b border-background-200/50">
              关于我们
            </Link>
            <Link to="/about" className="text-foreground-950 text-sm font-medium py-2">
              投稿入口
            </Link>
            <button className="mt-2 w-full py-2.5 rounded-full bg-foreground-950 text-background-50 text-sm font-medium">
              登录
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}